import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Crect width='300' height='300' fill='%23FDF4EE'/%3E%3Ctext x='50%25' y='50%25' font-size='20' fill='%23E35A38' text-anchor='middle' dy='.3em' font-family='sans-serif'%3ECadix%3C/text%3E%3C/svg%3E";

// Fallback for broken / blocked images (e.g. dead or ORB-blocked Unsplash URLs)
export const imgFallback = (e) => {
  if (e && e.currentTarget) {
    e.currentTarget.onerror = null;
    e.currentTarget.src = PLACEHOLDER;
  }
};

export const mediaUrl = (path) => {
  if (!path) return PLACEHOLDER;
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
};

export const formatDA = (n) => {
  const val = Math.round(Number(n) || 0);
  return `${val.toLocaleString("fr-FR").replace(/\u202f|\u00a0/g, " ")} DA`;
};

export const formatApiError = (detail) => {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export default api;
